const personalityImg = [
  {
    title: 'Jofra Archer',
    img: 'https://i.imgur.com/XQIh7tV.jpg',
  },
  {
    title: 'Nadine Coyle',
    img: 'https://i.imgur.com/CJ9w2LK.jpg',
  },
  {
    title: 'Tim Henman',
    img: 'https://i.imgur.com/Vi5cPRs.jpg',
  },
  {
    title: 'David Haye',
    img: 'https://i.imgur.com/mcOoLT4.jpg',
  },
  {
    title: 'Tom Daley',
    img: 'https://i.imgur.com/lc551Y6.jpg',
  },
  {
    title: 'Anthony Watson',
    img: 'https://i.imgur.com/UPoYsd8.jpg',
  },
  {
    title: 'British Rowing',
    img: 'https://i.imgur.com/gLQpMAt.jpg',
  },
  {
    title: 'Caroline Dubois',
    img: 'https://i.imgur.com/MZSFyve.jpg',
  },
  {
    title: 'Harlequins Rugby',
    img: 'https://i.imgur.com/ZIwyd7h.jpg',
  },
  {
    title: 'Sandi Toksvig',
    img: 'https://i.imgur.com/n26Rrsl.jpg',
  },
  {
    title: 'Liv Cooke',
    img: 'https://i.imgur.com/mNAiJT3.jpg',
  },
  {
    title: 'Eoin Morgan',
    img: 'https://i.imgur.com/GXb0sqs.jpg',
  },
  {
    title: 'Tracey Ann Oberman',
    img: 'https://i.imgur.com/fMMCANa.jpg',
  },
  {
    title: 'Mattey Lee',
    img: 'https://i.imgur.com/30s08rN.jpg',
  },
  {
    title: 'Maro Itoje',
    img: 'https://i.imgur.com/kfYsiAs.jpg',
  },
  {
    title: 'Graham Swann',
    img: 'https://i.imgur.com/kBPdlQa.jpg',
  },
  {
    title: 'Tom Daley',
    img: 'https://i.imgur.com/hieAMfW.jpg',
  },
  {
    title: 'Shane Williams',
    img: 'https://i.imgur.com/o101Ris.jpg',
  },
  {
    title: 'Women`s Prize for Fiction',
    img: 'https://i.imgur.com/glJjrN7.jpg',
  },
  {
    title: 'Ben Whittaker',
    img: 'https://i.imgur.com/r9yYyAp.jpg',
  },
  {
    title: 'Chris Robshaw',
    img: 'https://i.imgur.com/M5Zqz4X.jpg',
  },
  {
    title: 'Phil Tufnell',
    img: 'https://i.imgur.com/fWCIwAg.jpg',
  },
  {
    title: 'Tom Daley',
    img: 'https://i.imgur.com/2pAVKjW.jpg',
  },
  {
    title: 'Eoin Morgan',
    img: 'https://i.imgur.com/zqDgmxL.jpg',
  },
  {
    title: 'Grace Reid',
    img: 'https://i.imgur.com/5UUIL5F.jpg',
  },
  {
    title: 'British Sailing',
    img: 'https://i.imgur.com/xiRGkea.jpg',
  },
  {
    title: 'Amy Conroy',
    img: 'https://i.imgur.com/Jd3yx8u.jpg',
  },
  {
    title: 'Jos Buttler',
    img: 'https://i.imgur.com/uBvkbj3.jpg',
  },
  {
    title: 'Adrian Lester',
    img: 'https://i.imgur.com/TdeyP2L.jpg',
  },
  {
    title: 'Morgan Lake',
    img: 'https://i.imgur.com/Irzh3rx.jpg',
  },
];

export default personalityImg;
